import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import NotFound from "../../common/NotFound";

export default function AdminRoute() {
  const { user } = useSelector((state) => state.auth);
  const isAdmin = !!user?.admin;

  if (!isAdmin) {
    return <NotFound />;
  }

  return <Outlet />;
}